import script from "./CaskExtraArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskExtraArticle.vue?vue&type=script&setup=true&lang=js"

import "./CaskExtraArticle.vue?vue&type=style&index=0&id=d6e64ed0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6e64ed0"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QScrollArea,QList,QItem,QItemSection});qInstall(script, 'directives', {Ripple});
